import { Helmet } from "react-helmet-async";
import { buildCanonicalUrl, siteConfig } from "../../seo/siteConfig";

function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  keywords = [],
  schema = [],
  noindex = false,
}) {
  const resolvedTitle = title
    ? `${title} | ${siteConfig.siteName}`
    : siteConfig.defaultTitle;
  const resolvedDescription = description || siteConfig.defaultDescription;
  const canonical = buildCanonicalUrl(path);
  const resolvedImage = image || siteConfig.defaultImage;
  const mergedKeywords = [...siteConfig.keywords, ...keywords].join(", ");

  return (
    <Helmet prioritizeSeoTags>
      <html lang="tr" />
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <meta name="keywords" content={mergedKeywords} />
      <meta
        name="robots"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large"
        }
      />
      <meta name="theme-color" content={siteConfig.themeColor} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteConfig.siteName} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:locale" content={siteConfig.locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={siteConfig.twitterHandle} />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      <meta name="twitter:image" content={resolvedImage} />

      {schema
        .filter(Boolean)
        .map((item, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(item)}
          </script>
        ))}
    </Helmet>
  );
}

export default Seo;
